// Mirrors Finkit.Host.DeploymentNotices contracts
// (DeploymentNoticeAppService + DeploymentNoticeTemplateAppService).

// DeploymentNoticeStyle — numeric values are the wire contract.
export enum DeploymentNoticeStyle {
  Warning = 0,
  Alert = 1,
}

export interface ActiveNoticeSummaryDto {
  id: string;
  title: string;
  style: DeploymentNoticeStyle;
  remainingSeconds: number;
}

export interface DeploymentNoticeStatusDto {
  activeNotices: ActiveNoticeSummaryDto[];
  isActive: boolean;
}

export interface DeploymentNoticeTemplateDto {
  id: string;
  name: string;
  title: string;
  message: string;
  durationMinutes: number;
  style: DeploymentNoticeStyle;
}

export interface DeployResultDto {
  status: DeploymentNoticeStatusDto;
  savedTemplate?: DeploymentNoticeTemplateDto | null;
}

export interface DeployNoticeInput {
  title: string;
  message: string;
  durationMinutes: number;
  style: DeploymentNoticeStyle;
  templateId?: string | null;
  templateName?: string | null;
  targetTenantIds?: string[] | null;
}

export interface DeploymentNoticeTemplateInput {
  name: string;
  title: string;
  message: string;
  durationMinutes: number;
  style: DeploymentNoticeStyle;
}

export interface TenantOptionDto {
  id: string;
  name: string;
}

export interface DeploymentNoticeStyleOption {
  text: string;
  value: number;
}

export const MAX_NOTICE_TITLE_LENGTH = 200;
